// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2xxA3","colBig":"styles_colBig__21GAx","colSmall":"styles_colSmall__oCEeB"};